import classNames from "classnames";
import Styles from "./Button.module.scss";
import { Link, useNavigate } from "react-router-dom";

const Button = ({ text, className, onClick, to, disable }) => {
  const navigate = useNavigate();
  const isExternal = to?.startsWith("http://") || to?.startsWith("https://");
  const handleClick = (e) => {
    if (onClick) {
      onClick(e); // 執行傳入的 onClick 函數
    }
    if (to && !isExternal) {
      navigate(to);
    }
  };
  // 外部連結 → 用 <a>
  if (isExternal) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(Styles[`btn__${className}`])}
      >
        {text}
      </a>
    );
  }
  return (
    <div
      onClick={disable ? undefined : handleClick}
      className={
        disable
          ? classNames(Styles.btn__disable)
          : classNames(Styles[`btn__${className}`])
      }
    >
      {text}
    </div>
  );
};

export default Button;
